import React from 'react';
import styled from 'styled-components';

const StyledCircle = styled.div`
  width: 1em;
  height: 1em;
  border-radius: 50%;
  background: ${p => p.color};
`;

const Circle = ({ color }) => <StyledCircle color={color} />;

export default Circle;
